import { ONE_PAGE_STORE_TRACKER_TYPE } from '../../../../shop/constants/tracker';
import { getInjector } from '../../utils/getInjector';

export const onTrackCheckoutInput = async () => {
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');

  trackerService.track({
    type: ONE_PAGE_STORE_TRACKER_TYPE.CheckoutInput,
  });

  trackerService.track({
    type: trackerService.generalEventType.LOAD_CHECKOUT_PAGE,
  });
};
